import { toUpper } from 'lodash-es';

interface EnvPipe<T> {
  (value: T): any;
}

interface GetEnvValue {
  <K extends keyof ImportMetaEnv>(key: K): ImportMetaEnv[Uppercase<string & K>];
  <
    K extends keyof ImportMetaEnv,
    P extends EnvPipe<ImportMetaEnv[Uppercase<string & K>]>,
  >(
    key: K,
    pipe: P,
  ): ReturnType<P>;
}

export const getEnv = () => import.meta.env;
export const getEnvValue: GetEnvValue = <
  K extends keyof ImportMetaEnv & string,
  P extends EnvPipe<ImportMetaEnv[Uppercase<string & K>]>,
>(
  key: K,
  pipe?: P,
): P extends never ? ImportMetaEnv[Uppercase<string & K>] : ReturnType<P> => {
  const k = toUpper(key as string);
  const envValue = getEnv()[k] ?? window[k as any];

  return typeof pipe === 'function' ? pipe(envValue) : envValue;
};
